import React from 'react'
import { useTranslation } from 'react-i18next'

import store from 'store'
import { profilePush } from 'actions/index'
import addEditRecord from 'add_edit_modals'

import { PermissibleButton } from 'components/Permissible'
import { UPDATE, COMPANY } from 'permissions'

import { Section, Row, RowIcon, EditLink } from 'components/BusinessCard/components/StyledComponents'
import { H6, P, Link, Tooltip } from '@PipelineDeals/shared-react-components'

import { useBusinessCard } from 'components/BusinessCard/context'

const CompanyName = () => {
  const { t } = useTranslation()
  const { cardMeta: { showOnlyFields, showEmptyFields, showEditLink, showTooltips }, callbacks: { onClose }, resource } = useBusinessCard()

  if (!showOnlyFields.includes('company_name')) return null

  const companyId = resource.company_id || resource.company?.id
  const companyName = resource.company_name || resource.company?.name

  if (!showEmptyFields && (!companyId || !companyName)) return null

  const openCompanyEditModal = e => {
    e.stopPropagation()
    if (onClose) onClose(false)
    addEditRecord({ resourceType: 'company', resourceId: companyId })
  }

  const handleCompanyClick = event => {
    store.dispatch(profilePush({ event, type: 'Company', id: companyId }))
    if (onClose) onClose(false)
  }

  const renderEditLink = () => (
    <EditLink
      content={<RowIcon className="fas fa-pencil-alt" />}
      data-cypress="bc-edit-company"
      onClick={openCompanyEditModal}
    />
  )

  return (
    <Section data-cypress="business-card-company-name">
      <H6>
        {resource.company?.is_customer ? t('businessCard.labels.customer') : t('businessCard.labels.company')}
      </H6>

      <Row>
        <Link
          href={`/companies/${companyId}`}
          onClick={handleCompanyClick}
          withTextDecoration={false}
        >
          <P>
            {companyName}{resource.company_is_sample && ` (${t('businessCard.labels.sample')})`}
          </P>
        </Link>

        {showEditLink && (
          <div className="edit-link">
            <PermissibleButton
              action={UPDATE}
              cypress="bc-edit-company"
              policy={COMPANY}
              user={window.User}
            >
              {showTooltips ? (
                <Tooltip
                  content={t('common.buttons.edit')}
                  effect="solid"
                >
                  {renderEditLink()}
                </Tooltip>
              ) : (
                renderEditLink()
              )}
            </PermissibleButton>
          </div>
        )}
      </Row>
    </Section>
  )
}

export default CompanyName
